import { FragmentScreenViewDTO } from 'business/models/Models';
import FragmentService from 'business/services/FragmentService';
import React, { useEffect, useState } from 'react';

function FragmentInfoPanel({ fragmentId }: any) {
  const [data, setData] = useState<FragmentScreenViewDTO[]>([]);

  useEffect(() => {
    setData([]);
    fetchAndUpdateFragmentScreen();
  }, [fragmentId]);

  const fetchAndUpdateFragmentScreen = async () => {
    if (fragmentId == null) {
      return;
    }
    try {
      const fragmentService = new FragmentService();
      const fragmentData = await fragmentService.getFragmentScreen(fragmentId);
      if (!fragmentData) {
        return null;
      }
      if (fragmentData.fragmentScreenView) {
        setData(fragmentData.fragmentScreenView);
      }
    } catch {
      return;
    }
  };

  return (
    <div id="fragmentinfopanel-wrapper" className="overflow-y-auto h-[80%]">
      {data.map((fragment, index) => {
        return (
          <div
            id={`fragmentinfopanel-fragment-${index}-container`}
            className="border border-gray-600 rounded-md m-2"
            key={index}
          >
            <div
              id={`fragmentinfopanel-fragment-${index}-name`}
              className="font-bold flex-row w-full m-1"
            >
              {fragment.fragmentName}
            </div>
            <div
              id={`fragmentinfopanel-fragment-${index}-row-1`}
              className="grid grid-cols-2 gap-5 m-1"
            >
              <div id={`fragmentinfopanel-fragment-${index}-condition`}>
                Cond. Num :{fragment.conditionNumber || ''}
              </div>
              <div id={`fragmentinfopanel-fragment-${index}-id`}>
                ID &nbsp;&nbsp; :{fragment.fragmentID || ''}
              </div>
            </div>
            <div
              id={`fragmentinfopanel-fragment-${index}-row-2`}
              className="grid grid-cols-2 gap-5 m-1"
            >
              <div id={`fragmentinfopanel-fragment-${index}-concentration`}>
                Conc. (mM) :{fragment.workingConcentration || ''}
              </div>
              <div id={`fragmentinfopanel-fragment-${index}-size`}>
                Size :{fragment.size || ''}
              </div>
            </div>
            <div
              id={`fragmentinfopanel-fragment-${index}-notes`}
              className="flex-row w-full m-1"
            >
              Notes:
              <br />
              {fragment.notes || ''}{' '}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default FragmentInfoPanel;
